var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.tooltipText),expression:"tooltipText"}],staticClass:"absolute top-1/2 -translate-y-1/2 flex pointer-events-none rounded-lg px-3 py-2 z-10 border-solid w-max after:content-[' '] after:absolute after:border-transparent after:border-[12px] max-w-[200px]",class:[
    _vm.positionStyles[_vm.position],
    _vm.themes[_vm.theme]
  ]},[_c('span',{staticClass:"text-center"},[_vm._v("\n    "+_vm._s(_vm.tooltipText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }